import cx from "classnames";
import React, { ReactNode } from "react";

import { BreakoutWidth } from "@/components/BreakoutWidth";
import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";
import { PaddingWrapper } from "@/components/PaddingWrapper";
import useBreakpointTest from "@/hooks/useBreakpointTest";

import styles from "./styles.module.css";

export type CheckoutReviewBlockProps = {
  title: string;
  isEditing?: boolean;
  isEditable?: boolean;
  children: ReactNode;
  className?: string;
};

export const CheckoutReviewBlock = ({
  title,
  isEditing = false,
  isEditable = true,
  children,
  className,
}: CheckoutReviewBlockProps) => {
  const disableBreakout = useBreakpointTest("xs");
  return (
    <BreakoutWidth
      as="section"
      className={cx(
        styles.section,
        {
          [styles.sectionEditable]: isEditing,
        },
        className
      )}
      disable={!isEditing || disableBreakout}
    >
      <PaddingWrapper disable={!isEditing} onlyX>
        <Text as="h2" size="m" className={styles.sectionHeader}>
          {title}
          {isEditable && <Icon type="arrow_down" className={styles.arrow} />}
        </Text>
        {children}
      </PaddingWrapper>
    </BreakoutWidth>
  );
};
